/**
 * Derived from flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */
import { distance, type Ring } from "./math";

export function rotate(ring: Ring, target: Ring) {
  const length = ring.length;
  let min = Number.POSITIVE_INFINITY;
  let bestOffset = 0;

  for (let offset = 0; offset < length; offset += 1) {
    let sumOfSquares = 0;

    target.forEach((point, index) => {
      const delta = distance(ring[(offset + index) % length], point);
      sumOfSquares += delta * delta;
    });

    if (sumOfSquares < min) {
      min = sumOfSquares;
      bestOffset = offset;
    }
  }

  if (bestOffset) {
    const spliced = ring.splice(0, bestOffset);
    ring.splice(ring.length, 0, ...spliced);
  }
}
